import React, { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { CSSTransition } from 'react-transition-group';
import { Link, useHistory } from 'react-router-dom';
import cx from 'classnames';
import { ServiceCategoryFragment } from 'generated/graphql';
import Portal from 'components/Portal/Portal';

import s from './Categories.module.scss';

interface ICategories {
  categories: ServiceCategoryFragment[],
  showMenu: boolean,
  setShowMenu: (showMenu: boolean) => void,
}

const Categories = ({ categories, showMenu, setShowMenu }: ICategories) => {
  const isLaptop = useMediaQuery({ query: '(min-width: 720px)' });
  const history = useHistory();
  const blackoutRef = useRef(null);

  useEffect(() => {
    const clickListener = (e: MouseEvent) => {
      if (e.target === blackoutRef.current) {
        setShowMenu(false);
      }
    };
    window.addEventListener('click', clickListener);
    return () => window.removeEventListener('click', clickListener);
  }, []);

  useEffect(() => {
    setShowMenu(false);
  }, [history.location.pathname]);

  const isCurrentCategory = (alias: string) => history.location.pathname.includes(alias);

  const renderMenu = () => (
    <div className={s.Categories}>
      <ul className={s.CategoriesUl}>
        { categories && categories.map(({ name, alias, id }: ServiceCategoryFragment) => {
          const categoryAlias = `/${alias}`;
          return (
            <li
              key={id}
              className={cx(s.LinkWrapper, isCurrentCategory(alias)
                ? s.LinkWrapperActive : '')}
            >
              <Link
                className={s.Link}
                to={categoryAlias}
              >
                {name}
              </Link>
            </li>
          );
        }) }
      </ul>
    </div>
  );

  return (
    isLaptop ? (
      <>
        {renderMenu()}
      </>
    )
      : (
        <Portal>
          <div
            className={cx(s.Blackout, (showMenu ? s.BlackoutVisible : ''))}
            ref={blackoutRef}
          />
          <CSSTransition
            classNames="menu"
            in={showMenu}
            timeout={500}
            unmountOnExit
          >
            {renderMenu()}
          </CSSTransition>
        </Portal>
      )
  );
};

export default Categories;
